import axios from '@/api/config';
const classInfoStudent={
  pageList(data){
    return  axios.post(`${process.env.BASE_URL}/classInfoStudent/pageList`,data)
  },
  addClassInfoStudent(data){
    return  axios.post(`${process.env.BASE_URL}/classInfoStudent/batchAddClassInfoStudent`,data)
  },
  getClassInfoStudentList(data){
    return  axios.get(`${process.env.BASE_URL}/classInfoStudent/getClassInfoStudentList`,{params,data})
  },
  removeClassInfoStudent(data){
    return  axios.delete(`${process.env.BASE_URL}/classInfoStudent/deleteClassInfoStudent`,{data,data})
  },
  transferClass(data) {
    return axios.put(`${process.env.BASE_URL}/classInfoStudent/transferClass`, data );
  },
  copyStudent(data) {
    return axios.post(`${process.env.BASE_URL}/classInfoStudent/copyStudent`, data );
  },
}
export default classInfoStudent



// WEBPACK FOOTER //
// ./src/api/classInfoStudent.js